class MetaService {
    public static $inject: string[] = [
        "$rootScope",
        "$translate",
        "authService",
        "sitesService"
    ];

    public title: string;
    public faviconPath: string;

    private $t;
    private commonTitle: string;

    constructor (
        $rootScope,
        $translate: ng.translate.ITranslateService,
        authService,
        private sitesService
    ) {
        this.$t = $translate.instant;

        this.commonTitle = this.$t("atlas_par_site", { SITE: this.sitesService.siteName });
        this.setFavicon();
        this.setTitle();

        $rootScope.$on("$stateChangeSuccess", (_event, toState, _toParams, _fromState, _fromParams) => {
            const login = authService.getLogin();
            this.setTitle(toState.data?.title, login);
            this.setFavicon(toState.data?.favicon, toState.data?.title === "loki");
        });
    }

    public setFavicon(faviconPath?, isLoki?) {
        faviconPath = faviconPath || require(`../../assets/icons/favicon${
            isLoki ? "-loki" : ""
        }${
            this.sitesService.isAuctionDomain() ? "-auction" : ""
        }.ico`);
        const link = document.querySelector("link[rel='shortcut icon']");
        link.setAttribute("href", faviconPath);
        this.faviconPath = faviconPath;
    }

    public setTitle(title?, login?) {
        if (!title) {
            this.title = this.commonTitle;
        } else {
            this.title = Array.isArray(title)
                ? this.$t(title[0], title[1])
                : this.$t(title, { SITE: this.sitesService.siteName });

            if (!login) {
                this.title = `${this.title} | ${this.commonTitle}`;
            }
        }

        if (login) {
            this.title = `${login} | ${this.title}`;
        }
    }
}

angular
    .module("thor.core.meta", [])
    .service("metaService", MetaService);
